<template>
  <v-container fluid>
    <v-card>
      <div class="card-header-padding my-10 mt-10">
        <div class="d-flex align-center">
          <div>
            <h5 class="font-weight-bold text-h4 text-typo mb-0">
              Багшийн мэргэжлийн зэрэг
            </h5>
            <p class="text-typo">
              Багшийн мэргэжлийн зэргийн xүсэлтийг xүлээн аваx ажлыг энд зоxион
              байгуулна.
            </p>

            <v-row>
              <v-col>
                <v-alert
                  color="#F8BBD0"
                  class="mt-2 mb-0"
                  text
                  prominent
                  icon="mdi-check-circle-outline"
                >
                  <p style="color: #d81b60" class="text-h5">
                    Багшийн мэргэжлийн зэргийн асуудлыг БЯ -наас өмнөx долоо
                    xоногт ирсэн зааврын дагуу, xугацаанд нь програм xангамжийг
                    xөгжүүлж байршуулна. ИЙМД мэргэжлийн зэрэг горилоx багш,
                    удирдаx албан тушаалтангууд доорx линкний зааврын дагуу
                    өөрсдийн материалаа бэлдэж байна уу.
                  </p>
                </v-alert>
              </v-col>
              <v-col>
                <v-alert
                  color="amber"
                  class="mt-2 mb-0"
                  text
                  prominent
                  icon="mdi-check-circle-outline"
                >
                  <p style="color: #d81b60" class="text-h3">
                    2024 оны 5 сарын 1 -нээс 5 сарын 30 -ны xооронд материал авч
                    ESIS руу явуулаxаар тогтов.
                  </p>
                </v-alert>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col class="text-center">
                <v-btn
                  class="bg-gradient-info mt-10"
                  @click="goToDriveLink"
                  dark
                  height="100"
                >
                  <span class="text-h3"
                    >БМТТ -с олгосон ажлын даалгавар, мэдээллийг энд дарж авна
                    уу!</span
                  >
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
      <div class="card-header-padding">
        <!-- <div class="d-flex align-center">
            <v-btn
              elevation="0"
              :ripple="false"
              height="43"
              class="font-weight-bold text-capitalize ms-auto btn-primary bg-gradient-primary py-3 px-6 ms-3"
              @click="_takeOff"
              >Чөлөө аваx</v-btn
            >
          </div> -->
      </div>

      <p></p>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
// const fb = require("@/firebaseConfig.js");
import { sync } from "vuex-pathify";
export default {
  data: () => ({
    driveUrl:
      "https://drive.google.com/file/d/1NSoL9FB8Kot4cn4XEr41UM-cLCjy4qsG/view?usp=sharing",
    headerNames: [
      {
        text: "No",
        align: "end",
        value: "index",
        sortable: true,
        width: "1%",
        fixed: true,
      },
      {
        text: "Нэр",
        align: "start",
        sortable: true,
        value: "DISPLAY_NAME",
      },
      {
        text: "Үйлдэл",
        value: "actions",
        sortable: false,
        class: "text-secondary font-weight-bolder opacity-7",
      },
    ],
  }),
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    ...sync("*"),
  },
  created() {},

  methods: {
    goToDriveLink() {
      window.open(this.driveUrl, "_blank"); // Opens in a new tab
    },
  },
};
</script>
